/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const Marionette = require('backbone.marionette'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    // models & collections
    user = require('../models/user'),
    Contacts = require('../collections/contacts'),
    // views
    // Create = require('./create'),
    ModalDialog = require('./modalDialog'),
    Table = require('./table'),
    // utilities
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates,
    enumerations = require('../utilities/enumerations'),
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'contacts-list'
    },
    childViewEvents: {
        'edit:delete': 'onEditDelete',
        'edit:save':   'onEditSave',
        'make:primary': 'onMakePrimary',
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        table: {el: 'div[name=table]', replaceElement: true}
    },
    tagName: 'div',
    template: templates.contactsList,
    //
    initialize: function () {
        const contactsOptions = {};
        this.type = this.options.type;
        this.primaryRoleId = enumerations.codeValues[this.type === 'organization' ? 'organizationRoleTypePrimaryContact' : 'programRoleTypePrimaryContact'];
        this.adminRoleId = enumerations.codeValues[this.type === 'organization' ? 'organizationRoleTypeAdmin' : 'programRoleTypeAdmin'];
        this.templateContext = {
            hasAdminAccess: user.hasCapability('organization'),
            title: this.options.title,
            display: this.options.display
        };
        contactsOptions.type = this.type;
        if (this.type !== 'administrator') {
            this.id = this.options.id;
            contactsOptions.id = this.id;
            // this.collection = new Contacts([], {type: this.type, id: this.id});
            this.existingContacts = new Contacts([], {type: 'organization', id: this.type === 'organization' ? this.id : this.options.organizationId, full: true});
            this.listenTo(this.existingContacts, 'sync', _.bind(function (/*event*/) {
                this.existingContactsList = [];
                _.each(this.existingContacts.models, _.bind(function (model) {
                    if (!this.collection.get(model.id)) {
                        this.existingContactsList.push(model.id);
                    }
                }, this));
            }, this));
        }
        this.collection = new Contacts([], contactsOptions);
        this.listenTo(this.collection, 'remove', _.bind(function () {
            this.render();
        }, this));
        this.listenTo(this.collection, 'update sync', _.bind(function (collection, contacts) {
            if (['organization', 'program'].includes(contactsOptions.type)) {
                const primaryContact = _.find(contacts, function (contact) {
                    return contact.organizationRoleTypeId === 2;
                });
                this.getChildView('table').message(!primaryContact ? 'noPrimaryContactLabel' : null);
            }
        }, this));
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action,
            options = ['<option value="-1" selected>New contact</option>'];
        let form;
        switch (action) {
            case 'add':
                form = this.getChildView('table').create();
                _.each(this.existingContactsList, function (id) {
                    options.push('<option value="' + id + '">' + id + '</option>');
                });
                jQuery('select[name=existingContactId]', form).html(options.join('\n'));
                break;
            default:
                console.log('contactsList.onClickButton - action:%s', action);
                break;
        }
        return false;
    },
    onEditDelete: function (contactEmail) {
        let contact = this.collection.get(contactEmail);
        this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'contactLabel', name: contactEmail}, modalModal: this.type === 'organization' ? false : true});
        this.modalDialog.on('modalDialog:delete', _.bind(function () {
            const priorRoleTypeId = contact.attributes.organizationRoleTypeId || contact.attributes.programRoleTypeId;
            this.collection.remove(contact);
            contact.destroy();
            contact = null;
            if (priorRoleTypeId === this.primaryRoleId) {
                this.collection.makePrimary(null);
            }
        }, this));
    },
    onEditSave: function (serializedArray) {
        this.collection.update(serializedArray);
        return false;
    },
    onMakePrimary: function (id) {
        this.collection.makePrimary(id);
    },
    onRender: function () {
        this.showChildView('table', new Table({title: null, collection: this.collection, statify: _.bind(this.statify, this)}));
        return this;
    },
    statify: function (form, name) {
        let existingContact,
            id,
            contact;
        switch (name) {
            case 'existingContactId':
                id = form.find('select[name=existingContactId]').val();
                existingContact =  id !== '-1';
                if (existingContact) {
                    contact = this.existingContacts.get(id);
                }
                form.find('input[name=email]').prop('disabled', existingContact).val(existingContact ? contact.id : '');
                _.each(['first', 'last', 'title', 'phoneNumbersOnly'], _.bind(function (field) {
                    let value = '';
                    if (existingContact) {
                        switch (field) {
                            case 'phoneNumbersOnly':
                                value = helpers.telephone(contact.get(field));
                                break;
                            default:
                                value = contact.get(field);
                                break;
                        }
                    }
                    form.find('input[name=' + field + ']').prop('disabled', existingContact).val(value);
                }, this));
                break;
            default:
                break;
        }
    }
});
